// deps
import styled from "styled-components";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

const CTA_BUTTON_HEIGHT = "44px";

export const CancelBookingCTAWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    width: `calc(100% - ${theme.spacing.large})`,
    alignItems: "center",
    borderTop: `1px solid ${theme.colors[theme.colorMode].divider}`,
    paddingTop: theme.spacing.large,
    margin: `0 ${theme.spacing.medium}`,
}));

export const CancelBookingCTA = styled(TextButton)(() => ({
    width: "fit-content",
}));

export const CancelBookingPopupWrapper = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
}));

export const StyledHeaderText = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.medium,
}));

export const CTAContainer = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing.small,
}));

export const CTAButton = styled(SuperButton)(() => ({
    overflow: "hidden",
    height: CTA_BUTTON_HEIGHT,
}));
